export default {
	getHumanTime(sec) {
		if (!sec) return '';
		sec = Math.round(sec);
		
		let s = sec % 60;
		
		let min = Math.floor(sec / 60);
		let m = min % 60;
		
		let hr = Math.floor(min / 60);
		let h = hr % 24;
		let d = Math.floor(hr / 24);
		
		let str = s + 's';
		if (m) {
			str = m + 'm ' + str;
		}
		if (h) {
			str = h + 'h ' + str;
		}
		if (d) {
			str = d + 'd ' + str;
		}
		return str;
	},
	formatDate(datetime, format) {
		return moment(datetime).format(format);
	}
}